export class KpInfoDto {
    public timeTag!: string;
    public kp!: number;
}